'use strict';

import { logger } from '@/logging';


export default store => {
	const storeLogger = logger.get('store');
	const noDataMutations = [
		'auth/setAccessToken',
		'actions/addItems',
		'actions/addItem',
		'actions/updateItem',
		'likes/addItems',
		'likes/addItem',
		'likes/updateItem',
		'feedbacks/addItems',
		'feedbacks/addItem',
		'feedbacks/updateItem',
		'comments/addItems',
		'comments/addItem',
		'comments/updateItem',
		'users/addItem',
		'users/updateItem',
	];

	store.subscribe(({ type, payload }) => {
		if (payload === undefined || noDataMutations.indexOf(type) !== -1) {
			storeLogger.debug(type);
		}
		else {
			storeLogger.debug(type, payload);
		}
	});
};